export enum AccountTypesEnum {
    Real = 1,
    Earning = 2,
    Credit = 3,
    Bonus = 4
}
